export default __webpack_public_path__ + "media/images/transfer-window-placeholder-3ca291c4.png";